import { render, staticRenderFns } from "./nongzi.vue?vue&type=template&id=65e453c2&scoped=true&"
import script from "./nongzi.vue?vue&type=script&lang=js&"
export * from "./nongzi.vue?vue&type=script&lang=js&"
import style0 from "./nongzi.vue?vue&type=style&index=0&id=65e453c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e453c2",
  null
  
)

export default component.exports